module.exports = __webpack_public_path__ + "img/f-3-1.03602f85.png";